import {required } from "@vuelidate/validators";
const tlphaziryanitlar = {
    data() {
      return { 
        tlphaziryanitlarData:{  
          Baslik:null,
          Metin:null, 
        },  
          FormDataType:{
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:"Başlık",FieldType:"text"},
            Metin:{FieldName:"Metin",Field:"input",FieldTitle:"Metin",FieldType:"text"}, 
          }  
      } 
    },
    validations:{ 
      FormData: {
          Baslik: { required },  
          Metin: { required },  
      } 
  },
}
export default tlphaziryanitlar